import { Controller } from '@hotwired/stimulus';

// お問い合わせフォームの非同期送信。
// - モーダル (#contactModal): フォームを隠しお礼を表示。失敗時はフォーム先頭にエラー。
// - フッターフォーム (.quick_form): 送信後にフォーム直後へ結果メッセージを挿入し 5 秒で消す。
export default class extends Controller {
  static targets = ['formWrap', 'thanks'];

  async submit(event) {
    event.preventDefault();

    const form = this.element.matches('form') ? this.element : this.element.querySelector('form');
    if (!form) { return; }

    let ok = false;
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      });
      ok = response.ok;
    } catch {
      ok = false;
    }

    if (this.isModal) {
      this.renderModalResult(form, ok);
    } else {
      this.renderFooterResult(form, ok);
    }
  }

  get isModal() {
    return this.element.id === 'contactModal' || this.element.closest('#contactModal') !== null;
  }

  renderModalResult(form, ok) {
    const existingError = this.element.querySelector('#contact-modal-error');
    if (existingError) { existingError.remove(); }

    if (ok) {
      form.reset();
      if (this.hasFormWrapTarget) { this.formWrapTarget.classList.add('d-none'); }
      if (this.hasThanksTarget) { this.thanksTarget.classList.remove('d-none'); }
    } else {
      form.insertAdjacentHTML('afterbegin',
        '<div class="alert alert-danger" id="contact-modal-error">' +
        '<strong>送信に失敗しました。</strong><br>お手数ですが、もう一度お試しください。' +
        '</div>');
    }
  }

  renderFooterResult(form, ok) {
    form.reset();

    const id = ok ? 'contact-success-message' : 'contact-error-message';
    const existing = document.getElementById(id);
    if (existing) { existing.remove(); }

    const html = ok
      ? `<div class="alert alert-success mt-3" id="${id}">
           <strong>お問い合わせありがとうございました。</strong><br>
           担当者より折り返しご連絡を差し上げますので、しばらくお待ちください。<br>
           内容によっては、お時間をいただく場合や回答しかねる場合がございますので、あらかじめご了承ください。
         </div>`
      : `<div class="alert alert-danger mt-3" id="${id}">
           <strong>メールの送信に失敗しました。</strong><br>
           お手数ですが、もう一度お試しください。
         </div>`;

    form.insertAdjacentHTML('afterend', html);

    setTimeout(() => {
      const message = document.getElementById(id);
      if (message) {
        message.style.transition = 'opacity 0.5s';
        message.style.opacity = '0';
        setTimeout(() => message.remove(), 500);
      }
    }, 5000);
  }
}
